"use strict";
document.addEventListener("DOMContentLoaded", () => {
    // Mobile menu
    var toggle = document.querySelector(".gt-nav-toggle");
    var menu = document.querySelector(".gt-nav-menu");
    var overlay = document.querySelector(".gt-mobile-overlay");
    var header = document.querySelector(".gt-header");
    if (toggle && menu) {
        toggle.addEventListener("click", function () {
            var _a;
            if (menu.classList.contains("open")) {
                toggle === null || toggle === void 0 ? void 0 : toggle.classList.remove("open");
                menu === null || menu === void 0 ? void 0 : menu.classList.remove("open");
                overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove("active");
                (_a = menu === null || menu === void 0 ? void 0 : menu.querySelectorAll(".dropdown-menu.show")) === null || _a === void 0 ? void 0 : _a.forEach((dmenu) => dmenu.classList.remove("show"));
                document.body.style.overflow = "";
            }
            else {
                toggle === null || toggle === void 0 ? void 0 : toggle.classList.add("open");
                menu === null || menu === void 0 ? void 0 : menu.classList.add("open");
                overlay === null || overlay === void 0 ? void 0 : overlay.classList.add("active");
                document.body.style.overflow = "hidden";
            }
        });
    }
    document.querySelectorAll(".gt-nav-link").forEach((link) => {
        link.addEventListener("click", () => {
            var adminMenuDropdown = document.querySelector("ul.dropdown-menu[aria-labelledby='" + link.dataset.id + "']");
            if (!adminMenuDropdown)
                return;
            document.querySelectorAll(".dropdown-menu.show").forEach((dropdown) => {
                dropdown.classList.remove("show");
            });
            if (adminMenuDropdown.classList.contains("show")) {
                adminMenuDropdown.classList.remove("show");
                overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove("active");
            }
            else {
                adminMenuDropdown.classList.add("show");
                overlay === null || overlay === void 0 ? void 0 : overlay.classList.add("active");
            }
        });
    });
    if (overlay) {
        overlay.addEventListener("click", function () {
            toggle === null || toggle === void 0 ? void 0 : toggle.classList.remove("open");
            menu === null || menu === void 0 ? void 0 : menu.classList.remove("open");
            overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove("active");
            document.body.style.overflow = "";
            var dropdowns = document.querySelectorAll(".dropdown-menu.show");
            dropdowns.forEach((dropdown) => {
                dropdown.classList.remove("show");
            });
        });
    }
    window.addEventListener("scroll", function () {
        if (header) {
            if (window.scrollY > 0) {
                header.classList.add("scrolled");
            }
            else {
                header.classList.remove("scrolled");
            }
        }
    });
});
